export default async function getErrorFromResponse(response) {
	let errorMessage = response.statusText
	try {
		let resp = await response.json()
		errorMessage = resp.message || resp.error || JSON.stringify(resp)
	} catch (error) {
		// ignore
	}
	return errorMessage
}